import React from 'react';

import { Wrapper } from './Block.jsx';
import { EmptyPlaceholder } from '../utility/blocks';
import Name from '../utility/Name.jsx';
import Token from '../utility/Token.jsx';
import { Email } from '../../components/repositories/Type.jsx';
import TypeConfig from '../utility/TypeConfig.jsx';
import Utilities from '../utility/Utilities.jsx';

import { default as ClickToken } from '../../../../../artcloud.click/source/scripts/common/Token.jsx';

function ResourceMetaComponent(props) {
    const _artist = (props) => {
        let data = props.data || {};
        if (data.Artist) {
            data = data.Artist;
        } else {
            const inventory = _inventory(props);
            if (inventory.Artist) {
                data = inventory.Artist;
            }
        }
        return data;
    }
    const _contact = (props) => {
        let data = props.data || {};
        if (data.Contact) {
            data = data.Contact;
        }
        return data;
    }
    const _inventory = (props) => {
        let data = props.data || {};
        if (data.Inventory) {
            data = data.Inventory;
            if (Array.isArray(data) && data.length > 0) {
                data = data[0];
            }
        }
        return data;
    }
    const _recipient = (props) => {
        let data = props.data || {};
        if (data.Recipient) {
            data = data.Recipient;
        }
        return data;
    }
    const parseContent = (props, tokenizedString) => {
        if (!tokenizedString) {
            return '';
        }
        // const data = props.data || {};
        const contact = _contact(props);
        const inventory = _inventory(props);
        const recipient = _recipient(props);
        return ClickToken.parseTokenizedString(tokenizedString, (keyword, options) => {
            let replaceString = '';
            switch (keyword) {
                case Token.Resource.Contact.Email:
                    if (contact.Email && contact.Email.length > 0) {
                        replaceString = ClickToken.getReplacementString(contact.Email, options);
                    }
                    break;
                case Token.Resource.Contact.FirstName:
                    if (contact.FirstName && contact.FirstName.length > 0) {
                        replaceString = ClickToken.getReplacementString(contact.FirstName, options);
                    }
                    break;
                case Token.Resource.Contact.LastName:
                    if (contact.LastName && contact.LastName.length > 0) {
                        replaceString = ClickToken.getReplacementString(contact.LastName, options);
                    }
                    break;
                case Token.Resource.Contact.Message:
                    if (contact.Message && contact.Message.length > 0) {
                        replaceString = ClickToken.getReplacementString(contact.Message, options);
                    }
                    break;
                case Token.Resource.Contact.Name:
                    if (contact.Name && contact.Name.length > 0) {
                        replaceString = ClickToken.getReplacementString(contact.Name, options);
                    }
                    break;
                case Token.Resource.Contact.Offer.Amount:
                    if (contact.OfferAmount && contact.OfferAmount.length > 0) {
                        replaceString = ClickToken.getReplacementString(contact.OfferAmount, options);
                    }
                    break;
                case Token.Resource.Contact.Offer.Discount:
                    if (contact.OfferDiscount && contact.OfferDiscount.length > 0) {
                        replaceString = ClickToken.getReplacementString(contact.OfferDiscount, options);
                    }
                    break;
                case Token.Resource.Contact.Offer.Percent:
                    if (contact.OfferPercent && contact.OfferPercent.length > 0) {
                        replaceString = ClickToken.getReplacementString(contact.OfferPercent, options);
                    }
                    break;
                case Token.Resource.Contact.Phone:
                    if (contact.Phone && contact.Phone.length > 0) {
                        replaceString = ClickToken.getReplacementString(contact.Phone, options);
                    }
                    break;
                case Token.Resource.ArtistName:
                    const artist = _artist(props);
                    if (artist.Name && artist.Name.length > 0) {
                        replaceString = ClickToken.getReplacementString(artist.Name, options);
                    }
                    break;
                case Token.Resource.Inventory.Date:
                    if (inventory.Date && inventory.Date.length > 0) {
                        replaceString = ClickToken.getReplacementString(inventory.Date, options);
                    }
                    break;
                case Token.Resource.Inventory.Dimensions:
                    if (inventory.Dimensions && inventory.Dimensions.length > 0) {
                        replaceString = ClickToken.getReplacementString(inventory.Dimensions, options);
                    }
                    break;
                case Token.Resource.Inventory.Edition:
                    if (inventory.Edition && inventory.Edition.length > 0) {
                        replaceString = ClickToken.getReplacementString(inventory.Edition, options);
                    }
                    break;
                case Token.Resource.Inventory.Medium:
                    if (inventory.Medium && inventory.Medium.length > 0) {
                        replaceString = ClickToken.getReplacementString(inventory.Medium, options);
                    }
                    break;
                case Token.Resource.Inventory.Price:
                    if (inventory.Price && inventory.Price.length > 0) {
                        replaceString = ClickToken.getReplacementString(inventory.Price, options);
                    }
                    break;
                case Token.Resource.Inventory.Title:
                    if (inventory.Title && inventory.Title.length > 0) {
                        replaceString = ClickToken.getReplacementString(inventory.Title, options);
                    }
                    break;
                case Token.Resource.Recipient.Company:
                    if (recipient.Company && recipient.Company.length > 0) {
                        replaceString = ClickToken.getReplacementString(recipient.Company, options);
                    }
                    break;
                case Token.Resource.Recipient.Email:
                    if (recipient.Email && recipient.Email.length > 0) {
                        replaceString = ClickToken.getReplacementString(recipient.Email, options);
                    }
                    break;
                case Token.Resource.Recipient.EmailLink:
                    if (recipient.Email && recipient.Email.length > 0) {
                        let display = recipient.Email;
                        if (options && options.display && options.display.length > 0) {
                            display = options.display;
                        }
                        replaceString = `<a href="mailto:${recipient.Email}" style="color:inherit;">${display}</a>`;
                    }
                    break;
                case Token.Resource.Recipient.Name:
                    if (recipient.Name && recipient.Name.length > 0) {
                        replaceString = ClickToken.getReplacementString(recipient.Name, options);
                    }
                    break;
                case Token.Resource.Recipient.Phone:
                    if (recipient.Phone && recipient.Phone.length > 0) {
                        replaceString = ClickToken.getReplacementString(recipient.Phone, options);
                    }
                    break;
                default:
                    replaceString = undefined;
                    break;
            }
            if (replaceString == '' && options && options.default && options.default.length > 0) {
                replaceString = options.default;
                if (replaceString.trim().length == 0) {
                    replaceString = '&nbsp;'
                }
            }
            return replaceString;
        });
    }
    const artist = _artist(props);
    const contact = _contact(props);
    const inventory = _inventory(props);
    const design = props.blockConfig && props.blockConfig.block && props.blockConfig.block.design;
    const [content, setContent] = React.useState(undefined);
    React.useEffect(() => {
        setContent(parseContent(props, props.blockConfig.block.design));
    }, [artist.ArtistId, contact.ClientId, inventory.EditionId, design]);

    if (props.serverSide && content == undefined) {
        setContent(parseContent(props, props.blockConfig.block.design));
    }
    if (!props.builder && content != undefined && content.length == 0) {
        return null;
    }
    const { contentContainerStyle, contentStyle, innerStyle, wrapperStyle } = Utilities.parseTextWrapperConfig(props.blockConfig);
    return (
        <Wrapper {...props} className="SharedCaptionBlock" style={wrapperStyle}>
            <td align="center" className="SharedCaptionBlockInner" style={innerStyle} valign="top">
                <table
                    align="center"
                    border="0"
                    cellPadding="0"
                    cellSpacing="0"
                    className="SharedCaptionBottomContent"
                    style={contentContainerStyle}
                    width={props.maxWidth}>
                    <tbody>
                        <tr>
                            <td
                                className="SharedTextContent"
                                style={contentStyle}
                                valign="middle">
                                {
                                    content != undefined &&
                                    <div dangerouslySetInnerHTML={{ __html: content }} style={{ lineHeight: 1 }} />
                                }
                                {
                                    props.builder &&
                                    (content == undefined || content.length == 0) &&
                                    <EmptyPlaceholder fullWidth={true} />
                                }
                            </td>
                        </tr>
                    </tbody>
                </table>
            </td>
        </Wrapper>
    );
}
const ResourceMetaTokens = (context) => {
    let tokens = [
        Token.getWrappedTokenConfig('Recipient Company', Token.Resource.Recipient.Company, false),
        Token.getWrappedTokenConfig('Recipient Name', Token.Resource.Recipient.Name, false),
        Token.getWrappedTokenConfig('Recipient Email', Token.Resource.Recipient.Email, false),
        Token.getDisplayTokenConfig('Recipient Email Link', Token.Resource.Recipient.EmailLink),
        Token.getWrappedTokenConfig('Recipient Phone', Token.Resource.Recipient.Phone, false),
        Token.getWrappedTokenConfig('Contact Full Name', Token.Resource.Contact.Name, false),
        Token.getWrappedTokenConfig('Contact First Name', Token.Resource.Contact.FirstName, false),
        Token.getWrappedTokenConfig('Contact Last Name', Token.Resource.Contact.LastName, false),
        Token.getWrappedTokenConfig('Contact Email', Token.Resource.Contact.Email, false),
        Token.getWrappedTokenConfig('Contact Phone', Token.Resource.Contact.Phone, false)
    ]
    const inventoryTokens = [
        Token.getWrappedTokenConfig('Artist Name', Token.Resource.ArtistName, false),
        Token.getWrappedTokenConfig('Inventory Title', Token.Resource.Inventory.Title, false),
        Token.getWrappedTokenConfig('Inventory Created Date', Token.Resource.Inventory.Date, false),
        Token.getWrappedTokenConfig('Inventory Medium', Token.Resource.Inventory.Medium, false),
        Token.getWrappedTokenConfig('Inventory Dimensions', Token.Resource.Inventory.Dimensions, false),
        Token.getWrappedTokenConfig('Inventory Price', Token.Resource.Inventory.Price, false)
    ];
    switch (context) {
        case Email.ArtistSignup:
            tokens.push(Token.getWrappedTokenConfig('Artist Name', Token.Resource.ArtistName, false));
            break;
        case Email.InventoryInquiryResponse:
            tokens.push(Token.getWrappedTokenConfig('Message', Token.Resource.Contact.Message, false));
            tokens.push(...inventoryTokens);
            break;
        case Email.Offer:
            tokens.push(Token.getWrappedTokenConfig('Offer Amount', Token.Resource.Contact.Offer.Amount, false));
            tokens.push(Token.getWrappedTokenConfig('Offer Discount', Token.Resource.Contact.Offer.Discount, false));
            tokens.push(Token.getWrappedTokenConfig('Offer Percent', Token.Resource.Contact.Offer.Percent, false));
            tokens.push(...inventoryTokens);
            break;
        case Email.InquiryResponse:
        case Email.PurchaseConfirmation:
            tokens.push(Token.getWrappedTokenConfig('Message', Token.Resource.Contact.Message, false));
            break;
    }
    return tokens;
}
const ResourceMetaTypeConfig = {
    defaultDesign: `<p class="p" style="margin:0;padding:0;text-align:center;"></p>`,
    panel: {
        block: function () {
            const group = 'block';
            return {
                group,
                label: 'Content',
                options: [
                    {
                        display: 'Design resource meta here',
                        group,
                        name: 'design',
                        type: 'rich-text-campaign-short',
                        value: ResourceMetaTypeConfig.defaultDesign
                    },
                    {
                        display: 'Background Color',
                        group,
                        name: 'backgroundColor',
                        type: 'color'
                    },
                    {
                        display: 'Content Background Color',
                        group,
                        name: 'contentColor',
                        type: 'color'
                    },
                    {
                        display: 'Border Radius',
                        group,
                        name: 'borderRadius',
                        options: TypeConfig.options.measurement(),
                        type: 'measurement'
                    },
                    {
                        display: 'Border',
                        group,
                        name: 'border',
                        options: TypeConfig.options.measurement(),
                        type: 'border'
                    }
                ]
            };
        },
        layout: function () {
            const group = 'layout';
            return {
                group,
                label: 'Layout',
                options: [
                    {
                        disabled: ['marginLeft', 'marginRight', 'marginBottom', 'marginTop'],
                        display: 'Padding/Margin',
                        group,
                        max: '100',
                        name: 'paddingMargin',
                        options: TypeConfig.options.measurement(),
                        type: 'paddingMargin',
                        value: {
                            paddingBottom: { value: '9', unit: 'px' },
                            paddingTop: { value: '9', unit: 'px' }
                        }
                    }
                ]
            };
        }
    }
}
const ResourceMetaBlockTypeDefinition = (group) => {
    return {
        id: Name.Block.ResourceText,
        config: {
            block: ResourceMetaTypeConfig.panel.block(),
            layout: ResourceMetaTypeConfig.panel.layout()
        },
        display: 'Resource Meta Text',
        group,
        image: 'resource_meta_text.png'
    };
}
export { ResourceMetaBlockTypeDefinition, ResourceMetaComponent, ResourceMetaTokens, ResourceMetaTypeConfig }